import { orderBy } from 'lodash-es';
import { ReservationData } from '@/api/apis/resources';
import { getGroupedReservationsOnCase } from '@/utils/helpers';

export const getLastInUseDetails = (reservations: ReservationData[]) => {
  const [completed, current] = getGroupedReservationsOnCase(reservations);
  if (current.length) {
    return `On Case: ${current[0].caseName}`;
  }
  if (completed.length) {
    const lastCompleted = orderBy(completed, 'modifiedAt', 'desc')[0];
    return `Last Case: ${lastCompleted.caseName}`;
  }
  return '';
};
